'use strict';

const React = require( 'react' );
const propTypes = require('prop-types');
const DateHelper = require( '../../../../../_plugins/lib/dateHelper' );
const { object } = propTypes;
const createReactClass = require('create-react-class');

const ReviewItem = createReactClass({
  mixins: [DateHelper],

  propTypes: {
    item: object.isRequired
  },

  render() {
    const { item: {
      cid,
      comment_date: commentDate,
      name,
      product_name: productName,
      score,
      comment
    } } = this.props;

    const dateFormat = this.formatDateToDddMMyy( this.parseIsoDate( commentDate.split( ' ' )[0] ));
    return (
      <div key={ cid }>
        <p><strong>{ productName }</strong></p>
        <blockquote>
          { comment }
        </blockquote>
        <strong>
          <span className="author">{ name }</span> <span>{ dateFormat }</span>
        </strong>
        <p className="redFont">
          (<span>{ score * 2 }</span> out of <span>10</span>)
        </p>
      </div>
    );
  }
});

module.exports = ReviewItem;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/reviews/reviewItem.jsx